import { NgModule } from '@angular/core';

import { TrainSchedulesRoutingModule } from './train-schedules-routing.module';
import { TrainScheduleDashboardComponent } from './containers/train-schedule-dashboard/train-schedule-dashboard.component';
import { TrainScheduleComponent } from './components/train-schedule/train-schedule.component';
import { TimetableComponent } from './components/timetable/timetable.component';
import { TrainScheduleEditComponent } from './components/train-schedule-edit/train-schedule-edit.component';
import { TimetableEditComponent } from './components/timetable-edit/timetable-edit.component';
import { TRAIN_SCHEDULE_STATES } from './train-schedules.states';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { ReferenceAreaListFilterByType} from './pipes/reference-area-list-filter-by-type';


@NgModule({
  declarations: [TrainScheduleDashboardComponent, TrainScheduleComponent, TimetableComponent, TrainScheduleEditComponent, TimetableEditComponent, ReferenceAreaListFilterByType],
  imports: [
    SharedModule,
    TrainSchedulesRoutingModule,
    UIRouterModule.forChild({ states: [...TRAIN_SCHEDULE_STATES]  })
  ],
  entryComponents: [
    TrainScheduleEditComponent
  ]
})
export class TrainSchedulesModule { }
